import {
  api,
  CertificationTypeStatuses,
  Country,
  ProductFamilyGroup,
  Role2,
  TimeZoneSimple,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const examinerDictionariesApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getTimezones: builder.query<TimeZoneSimple[], void>({
      query: () => api.timeZone.getAll(),
    }),
    getAllCountries: builder.query<Country[], void>({
      query: () => api.country.getAllCountries(),
    }),
    getExaminerRoles: builder.query<ProductFamilyGroup[], void>({
      query: () => api.examiner.getExaminerRoles(),
    }),
    getCertificationTypeStatuses: builder.query<CertificationTypeStatuses[], void>({
      query: () => api.certificationType.getCertificationTypeStatuses(),
    }),
    getAllRoles: builder.query<Role2[], void>({
      query: () => api.role.getAll(),
    }),
  }),
});

export const {
  useGetTimezonesQuery,
  useGetAllCountriesQuery,
  useGetExaminerRolesQuery,
  useGetCertificationTypeStatusesQuery,
  useGetAllRolesQuery,
} = examinerDictionariesApi;
